<div class="flex flex-col">
  <p class="text-md font-bold text-center">{{ $safeNavigationMigration(data?.messageTranslationId)| translate }}</p>
</div>